import {useEffect, useState} from "react";

function Hole({className, diameter = 270}) {
    const [x, setX] = useState('0%');
    const [y, setY] = useState('0%');

    useEffect(() => {
        const interval = setInterval(() => {
            const el = document.querySelector(className);

            if (el) {
                const rect = el.getBoundingClientRect();

                const docWidth = Math.max(
                    document.documentElement.scrollWidth,
                    document.body.scrollWidth
                );
                const docHeight = Math.max(
                    document.documentElement.scrollHeight,
                    document.body.scrollHeight
                );

                const centerX = rect.left + rect.width / 2 + window.scrollX;
                const centerY = rect.top + rect.height / 2 + window.scrollY;

                const percentCoords = {
                    x: (centerX / docWidth) * 100,
                    y: (centerY / docHeight) * 100,
                };

                if(percentCoords.x > 0 && percentCoords.y > 0) {
                    setX(percentCoords.x + '%');
                    setY(percentCoords.y + '%');
                    clearInterval(interval); // Stop retrying after success
                }
            }
        }, 500); // Retry every 0.5 second

        return () => clearInterval(interval); // Clean up on unmount
    }, [className]);

    if(x === '0%'){
        diameter = 0;
    }

    return (
        <div
            className="holeMask"
            style={{
                ['--hole-r' as any]: diameter + 'px',
                ['--hole-x' as any]: x,
                ['--hole-y' as any]: y,
            }}
        >
        </div>
    )
}

export default Hole;